import type { RobawsKind } from "./enums.js";

/** Robaws-advies; zelfde regels als `suggestRobaws` in het prototype. */
export function suggestRobaws(
  a: { solver?: string; size?: string } | null | undefined,
): Extract<RobawsKind, "order" | "offer"> | null {
  if (!a) return null;
  if (a.solver === "aannemer" || a.solver === "klant") return null;
  if (a.size === "groot" || a.solver === "specialist") return "offer";
  return "order";
}
